module.exports = __webpack_public_path__ + "img/newempty-chat.ba5d4c89.svg";